import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import styles from './style.module.css';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, LANG_PREF } from './../../content/constants';
import { useQuery } from './../../hooks/useQuery';
import { getAuthorizeUrl } from 'src/helpers/utils';

const I18nLanguageSelector = () => {
  const { t } = useTranslation();
  const [lang, setLang] = useState('');
  const [cookie, setCookie] = useCookies([LANG_PREF]);
  let query = useQuery();

  const [showOptions, setShowOptions] = useState(false);

  useEffect(() => {
    const lang = LANGUAGES.find((item) => item.id === (query.get('lang') || cookie?.gs_lang_pref));
    setLang(lang?.name);
  }, [cookie, query]);

  const toggleShowLang = (e) => {
    e.preventDefault();
    setShowOptions(!showOptions);
  };

  const hideLang = (e) => {
    e.preventDefault();
    setShowOptions(false);
  };

  const handleClick = (lang) => {
    setLang(lang.name);
    setCookie(LANG_PREF, lang.id, { path: '/'});
    setShowOptions(false);
    window.location = getAuthorizeUrl(lang.id);
  };

  return (
    <div className={styles.supported_languages} onMouseLeave={hideLang}>
      <span className={styles.selected_lang} onClick={toggleShowLang}>
        {lang}  <svg className={`${showOptions ? styles.open : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.75 1.125L5 4.875L1.25 1.125" stroke="#5F6880" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
      </svg>
      </span>
      {showOptions && (
        <div className={`${styles.language_list}`}>
          <p>{t('select_your_language')}</p>
          <ul>
            {LANGUAGES.map((lang) => (
              <li key={lang.id} onClick={() => handleClick(lang)}>
                {lang.name} {`(${lang.id})`}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default I18nLanguageSelector;
